window.addEventListener('DOMContentLoaded', function() {
    ( function( $ ) {        

        var portfolioSectorSlickSettings = {
            dots: false,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 2750,
            infinite: false,
            slidesToShow: 1,
            pauseOnHover: true,
            fade: false,
            cssEase: 'linear',
            initialSlide: setFirstSlide,
            speed: 750,
            mobileFirst: true,
            responsive:[{
                    breakpoint:1024,
                    settings: "unslick"
            }]
        };

        var sl = "";

        $(document).ready(function(){

            setHeightCarousel();
            setHeightPortfolioSectors();

            objectFitPolyfill();

            $(window).bind('resizeEnd', function () {

                setHeightCarousel();
                setHeightPortfolioSectors();

            }); 

            // Swap the nav elements to alternative 'white' mode.
            if($('.mainNav').hasClass('scrolled')){        
                $('#nav').removeClass('altNav');
                $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
            }else{
                $('#nav').addClass('altNav');
                $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
            }

            $('body').on('click', '.hamburger', function () {

               if($('.mainNav').hasClass('hamburgerActive')){        
                    $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
                }else{
                    if(!$('.mainNav').hasClass('scrolled')){ 
                        $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
                    }
                } 

            });

            var sl = $('.portfolioSectorMobileCarousel').slick(portfolioSectorSlickSettings);

            $('.portfolio-carousel').slick({
                dots: true,
                autoplay: true,
                autoplaySpeed: 5000,
                infinite: true,
                slidesToShow: 3,
                fade: false,
                cssEase: 'ease-in-out',
                speed: 1000,
                slide: '.altCarouselItem',
                responsive: [{
                    breakpoint: 767, // mobile breakpoint
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480, // mobile breakpoint
                    settings: {
                        slidesToShow: 1
                    }
                }]
            });

        });

        $( window ).scroll(function() {

            setTimeout(function(){
                if($('.mainNav').hasClass('scrolled')){        
                    $('#nav').removeClass('altNav');
                    $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
                }else{
                    //if($(window).scrollTop() > 20) {
                        $('#nav').addClass('altNav');
                        $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
                    //}
                }
            }, 200);

        });

        $( window ).on('resize', function(){

            if( $( window ).width() < 1025 && !$('.portfolioSectorMobileCarousel').hasClass('slick-initialized')){
                $('.portfolioSectorMobileCarousel').slick(portfolioSectorSlickSettings);
            }

        });


        function setHeightCarousel(){

            $('.videoHeight').css('height', 'inherit');

            var getVideoContainerHeight = $('.videoContainer').height();

            $('.videoHeight').css('height', '' + (getVideoContainerHeight + 20) + 'px');

        }

        function setHeightPortfolioSectors(){

            $('.portfolioInner').css('height', 'inherit');

            var setHeight = 0;

            setTimeout(function(){

                $('.portfolioSector').each(function(){

                    //console.log($(this).attr('class'));
                    //console.log($(this).height());

                    if($(this).height() > setHeight){setHeight = $(this).height();}

                    //console.log(setHeight);

                });

                //console.log(setHeight);

                $('.portfolioInner').css('height', (setHeight+10) + 'px');

            }, 500);

        }

    } )( jQuery );
});